var _defs, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgHamidiye(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "katman_1",
    "data-name": "katman 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 35 35",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: #fff;\n        stroke-width: 0px;\n      }\n    "))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M12.1,25.9c-3.4.7-5.4-1.6-7.5-3.7-.8-.7-1.3-1.7-2.5-1.9-2.5-.4-2.6-2-1.9-3.7.9-2.2,2.2-4.2,3.4-6.3.3-.5.8-.7,1.4-.6,8.8,1.7,17.4-.8,26.1-.7,1.5,0,2.7.2,3.3,1.9.9,2.6.5,3.5-2.2,4.2-2.1.5-4.3,1-6.5,1.2-4.3.3-7,2.8-8.5,6.6-1,2.7-2.6,3.5-5.3,3.1Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHamidiye);
export default __webpack_public_path__ + "static/media/hamidiye.5ae3deb6a6a2ac929c1db727fe664635.svg";
export { ForwardRef as ReactComponent };